/**
 * Determines the active toolbar tab based on the current pathname
 * @param pathname - The current URL pathname
 * @returns The active tab value ('flight', 'hotel', 'offers', 'account', 'experience')
 */
export const getActiveToolbarTab = (pathname: string): string => {
    // Remove locale prefix if present (e.g., /en/hotel -> /hotel)
    const pathWithoutLocale = pathname.replace(/^\/(en|ar)/, '')

    // Check for specific routes
    if (pathWithoutLocale.startsWith('/hotel')) {
        return 'hotel'
    }

    if (pathWithoutLocale.startsWith('/offers')) {
        return 'offers'
    }

    if (pathWithoutLocale.startsWith('/experience')) {
        return 'experience'
    }

    if (pathWithoutLocale.startsWith('/account') || pathWithoutLocale.startsWith('/trips') || pathWithoutLocale.startsWith('/wallet')) {
        return 'account'
    }

    // Default to 'flight' for home page and flight-related pages
    return 'flight'
}
